import React from "react";
import CustomCheckbox from "../../common/components/elements/checkbox/CustomCheckbox";
import {FieldContainer} from "../../common/components/collections/form/forms";
import {Field} from "react-final-form";
import styled from "styled-components";
import useSite from "../../sites/hooks/useSite";
import {showErrorHighlight} from "src/core/common/utils";

function MarketingOptInField({requestEmail, requestPhone, hasErrors}) {
  const site = useSite();

  const sanitizeMarketingConsentSmsText = () => ({
    __html: site.getOptions().getMarketingConsentSmsText(),
  });

  const sanitizeMarketingConsentEmailText = () => ({
    __html: site.getOptions().getMarketingConsentEmailText(),
  });

  return (
    <div>
      {requestPhone && (
        <Field
          name="marketingSmsOptIn"
          render={({input, meta}) => (
            <FieldContainer>
              <Container
                onClick={() => input.onChange(!input.value)}
                hasErrors={hasErrors}
              >
                <CustomCheckbox
                  {...input}
                  color={"black"}
                  type={"checkbox"}
                  checked={input.value}
                  onChange={input.onChange}
                  label="Receive marketing SMS"
                />
                <Text
                  onClick={() => input.onChange(!input.value)}
                  hasErrors={showErrorHighlight(meta)}
                >
                  <SanitizedText
                    dangerouslySetInnerHTML={sanitizeMarketingConsentSmsText()}
                  />
                </Text>
              </Container>
            </FieldContainer>
          )}
        />
      )}
      {requestEmail && (
        <Field
          name="marketingEmailOptIn"
          render={({input, meta}) => (
            <FieldContainer>
              <Container
                onClick={() => input.onChange(!input.value)}
                hasErrors={hasErrors}
              >
                <CustomCheckbox
                  {...input}
                  color={"black"}
                  type={"checkbox"}
                  checked={input.value}
                  onChange={input.onChange}
                  label="Receive marketing Email"
                />
                <Text
                  onClick={() => input.onChange(!input.value)}
                  hasErrors={showErrorHighlight(meta)}
                >
                  <SanitizedText
                    dangerouslySetInnerHTML={sanitizeMarketingConsentEmailText()}
                  />
                </Text>
              </Container>
            </FieldContainer>
          )}
        />
      )}
    </div>
  );
}

export const Container = styled.div`
  display: flex;
  font-size: ${({theme}) => theme.v2.typography.sizing.m.lg};
  line-height: 18px;
  color: ${({hasErrors, theme}) => (hasErrors ? "red" : theme.v2.color.base.grey["900"])};
  margin-top: ${({theme}) => theme.v2.spacing(2)};
`;
const Text = styled.div`
  cursor: pointer;
`;
const SanitizedText = styled.div`
  > p {
    margin: 0;
  }
`;

export default MarketingOptInField;
